import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AuthGuard } from './components/AuthGuard';
import { Layout } from './components/Layout';
import Login from './pages/Login';
import Overview from './pages/Overview';
import MetaAds from './pages/MetaAds';
import GoogleAds from './pages/GoogleAds';
import Kommo from './pages/Kommo';
import CampaignTags from './pages/CampaignTags';
import Financeiro from './pages/Financeiro';

const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { path: '/', element: <Overview /> },
      { path: '/meta-ads', element: <MetaAds /> },
      { path: '/google-ads', element: <GoogleAds /> },
      { path: '/kommo', element: <Kommo /> },
      { path: '/campaign-tags', element: <CampaignTags /> },
      { path: '/financeiro', element: <Financeiro /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);

export default function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
